/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ComponentProps, ReactElement } from 'react';
import { cssMap } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import type { Status as OriginalStatus } from '@atlaskit/renderer/nodes';
import { token } from '@atlaskit/tokens';

import type { LightNodeProps } from '../LightNodeObserver.ts';

const styles = cssMap({
	status: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderColor: 'transparent',
		borderRadius: token('radius.small'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		boxSizing: 'border-box',
		display: 'inline-flex',
		font: token('font.body.small'),
		height: '1.25rem',
		maxWidth: '200px',
		overflow: 'hidden',
		paddingBlockStart: token('space.025'),
		paddingBlockEnd: token('space.025'),
		paddingInlineStart: token('space.050'),
		paddingInlineEnd: token('space.050'),
		verticalAlign: 'middle',
		whiteSpace: 'nowrap',
	},
	text: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});

export const Status = (
	props: ComponentProps<typeof OriginalStatus> & LightNodeProps,
): ReactElement => (
	<span
		ref={props.lightNodeRef}
		css={styles.status}
		data-color={props.color}
		data-local-id={props.localId}
		data-node-type="status"
		role="emphasis"
	>
		<span css={styles.text}>
			{props.style === 'mixedCase' ? props.text : props.text.toUpperCase()}
		</span>
	</span>
);
